Object.entries = function (obj) {
  const entries = [];
  const inValidTypes = ['number', 'string', 'boolean','function','symbol'];
  if(Array.isArray(obj)) {
    return obj.map((value, index) => {
      return [ String(index), value]
    })
  }
  if (inValidTypes.includes(typeof obj) || obj === null || obj === undefined || obj === NaN) {
    console.trace("Custom Object.entries called!", obj, typeof obj);
    return entries
  }

  for (const key in obj) {
    if (obj?.[key]) {
      entries.push([key, obj[key]]);
    }
  }
  return entries;
};


